import { getSnowplowEventPayload, logAnalyticsEvent } from '../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../analytics.const';

interface TriggerAddSavedSearchDailyStockToggleProps {
	savedSearchName: string;
	sendEmailAlert: boolean;
}

const {
	MARKETPLACE: { ADD_SAVED_SEARCH },
} = ANALYTICS_CATEGORIES;

export const triggerAddSavedSearchButtonClickEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ADD_SAVED_SEARCH,
		name: 'dlr_saved_search_save_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerSaveFilterButtonClickedEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ADD_SAVED_SEARCH,
		name: 'dlr_saved_search_save_confirmed',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerAddSavedSearchDailyStockToggleEvent = ({
	savedSearchName,
	sendEmailAlert,
}: TriggerAddSavedSearchDailyStockToggleProps): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ADD_SAVED_SEARCH,
		customData: { label: savedSearchName },
		name: `dlr_add_saved_search_daily_stock_${sendEmailAlert ? 'on' : 'off'}`,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
